export const TIPO_FICHAJE = {
  entrada: { label: "Entrada", className: "border-green-200 bg-green-100 text-green-700" },
  salida: { label: "Salida", className: "border-zinc-200 bg-white text-zinc-600" },
  pausa: { label: "Pausa", className: "border-amber-200 bg-amber-100 text-amber-800" },
  vuelta: { label: "Vuelta", className: "border-sky-200 bg-sky-100 text-sky-700" },
  cambio_proyecto: { label: "Cambio de proyecto", className: "border-violet-200 bg-violet-100 text-violet-800" },
  registro_visita: { label: "Registro de visita", className: "border-rose-200 bg-rose-50 text-rose-800" },
};

export const PAUSA_LABEL = {
  cafe: "Pausa café",
  comida: "Comida",
  personal: "Personal",
  fumar: "Fumar",
  otro: "Otro",
  medico: "Médico", // histórico
};

export function nowLocalInput() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

export function toLocalInput(iso) {
  if (!iso) return nowLocalInput();
  const d = new Date(typeof iso === "string" ? iso.replace(/ /g, "+") : iso);
  if (Number.isNaN(d.getTime())) return nowLocalInput();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}

/** Envía datetime-local al API como hora local (sin convertir a UTC en el navegador). */
export function toApiLocalTimestamp(localInput) {
  const v = (localInput || "").trim();
  if (!v || v.length < 16) {
    throw new Error("Indica fecha y hora del picado");
  }
  // backend parse_ts_local espera ISO sin Z → interpreta en TZ de la app
  return v.length === 16 ? `${v}:00` : v;
}

export function fichajeEsReal(f) {
  return f?.id > 0;
}
